var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{staticClass:"avatar-uploader",style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"name":"avatar","list-type":"picture-card","show-upload-list":false,"action":null,"before-upload":_vm.beforeUpload,"custom-request":_vm.customRequestHandler},on:{"change":_vm.handleChange}},[(_vm.imageUrl && !_vm.loadingFile)?_c('div',{staticClass:"avatar-wrapper",style:({
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      minWidth: _vm.width + 'px',
      minHeight: _vm.height + 'px',
      borderRadius: '50%'
    })},[_c('img',{style:({
        width: _vm.width + 'px',
        height: _vm.height + 'px',
        minWidth: _vm.width + 'px',
        minHeight: _vm.height + 'px',
        borderRadius: '50%'
      }),attrs:{"src":_vm.imageUrl,"alt":"logo"}}),_c('div',{staticClass:"overlay"},[_c('a-icon',{attrs:{"type":"edit","theme":"twoTone","twoToneColor":"#fff"}})],1)]):_c('div',{staticClass:"flex flex-column align-items-center justify-content-center",style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},[_c('a-icon',{attrs:{"type":_vm.loadingFile ? 'loading' : 'plus'}}),_c('div',{staticClass:"ant-upload-text"},[_vm._v("Upload")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }